module.exports = __webpack_public_path__ + "img/bg-1.a0c60aa0.jpeg";